'use client';

import { useMemo } from 'react';
import { useAuthSession } from '@/components/rbac/AuthSessionProvider';
import {
	resolveInvestigatorProfilePermissions,
	type ProfilePermissionTarget,
} from '@/components/rbac/investigatorProfilePolicy';

interface UseInvestigatorProfilePermissionsInput {
	targetProfile: {
		slug: string;
		email?: string | null;
		idInvestigador?: number | null;
	};
	targetUnit?: {
		id?: string | null;
	};
	targetMacroUnit?: {
		id?: string | null;
	};
}

export function useInvestigatorProfilePermissions({
	targetProfile,
	targetUnit,
	targetMacroUnit,
}: UseInvestigatorProfilePermissionsInput) {
	const { user, status } = useAuthSession();

	const target = useMemo<ProfilePermissionTarget>(
		() => ({
			slug: targetProfile.slug,
			email: targetProfile.email,
			idInvestigador: targetProfile.idInvestigador,
			unitId: targetUnit?.id,
			macroUnitId: targetMacroUnit?.id,
		}),
		[targetProfile.slug, targetProfile.email, targetProfile.idInvestigador, targetUnit?.id, targetMacroUnit?.id],
	);

	const permissions = useMemo(
		() =>
			resolveInvestigatorProfilePermissions({
				viewer: {
					isAuthenticated: Boolean(user),
					role: user?.role ?? null,
					email: user?.email,
					idInvestigador: user?.idInvestigador ?? null,
					// TODO: rbac - unitId no disponible en sesión aún.
					unitId: null,
					// TODO: rbac - macroUnitId no disponible en sesión aún.
					macroUnitId: null,
				},
				target,
			}),
		[user, target],
	);

	return {
		status,
		user,
		...permissions,
	};
}
